import React, { PureComponent } from 'react';
import { Text } from 'react-native';
import { getConfig } from '../../config/index';
import { Logger } from '../../utils';

interface IProps {
  children: React.ReactNode;
  childTreeName: string;
}

interface IState {
  hasError: boolean;
}

class ErrorBoundary extends PureComponent<IProps, IState> {
  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const { childTreeName } = this.props;

    Logger.notify(error, (report) => {
      report.errorClass = childTreeName;
    });
  }

  public errorFallback() {
    const { childTreeName } = this.props;
    const config = getConfig();
    if (!config.isProductionEnvironment) {
      return <Text>{`Error caught at error boundary name: ${childTreeName}`}</Text>;
    }
    return <></>;
  }

  public render() {
    const { hasError } = this.state;

    if (hasError) {
      return this.errorFallback();
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
